import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { CoreModule } from './core/core.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ContactsComponent } from './components/about/contacts/contacts.component';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastsComponent } from "./shared/components/toasts/toasts.component";
import { GoogleMapsModule } from '@angular/google-maps';
import { SharedModule } from './shared/shared.module';
  
@NgModule({
  declarations: [
    AppComponent,
    ContactsComponent,
    
   ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    // ComponentsModule,
    CoreModule,
    GraphQLModule,
    HttpClientModule,
    ReactiveFormsModule,
    ToastsComponent,
    

],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
